import React, { Component } from "react";
import { Row, Col, Button, Form, Card } from "react-bootstrap";
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import compose from "lodash.flowright";
import { graphql, withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import SelectDropDown from "../selectdropdown/SelectDropDown";
import "./_pdf.scss";

/* ---------------- GRAPHQL ---------------- */

const FETCH_PDF_FILES_DATA = gql`
  query AIMLQuestionBankCollegePdf($exams: [String], $institute_id: Int!, $pexam_type: String, $page: Int, $limit: Int) {
    getAIMLFiles: getAIMLQuestionBankCollegePdf(exams: $exams, institute_id: $institute_id, pexam_type: $pexam_type, page: $page, limit: $limit) {
      id
      file_name
      exam_name
      pexam_type
      timestamp
    }
  }
`;

const FETCH_GLOBALS = gql`
   query globals($institution_id: Int!) {
    globals(institution_id: $institution_id){
        exams{
            id
            exam
        }
        classes{
            id
            class
        }
    }
}`;

const API_BASE = "https://ai.rizee.in/vignan-pdf-ext";
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const EXAM_TYPE_OPTIONS = [
  { value: 1, label: "Mains" },
  { value: 2, label: "Advance" },
];

/*
 * Upload-mode configuration.
 *  - key       -> /vig-answerkey : only ANSWER KEY sheet extraction (1 PDF)
 *  - solutions -> /vig-solution  : only EXPLANATION extraction (1 PDF)
 *  - both      -> /vig-autoext   : ANSWER KEY + EXPLANATION together (2 PDFs)
 */

//  Question AND Solution
// https://ai.rizee.in/vignan-pdf-ext/vig-autoext  

// https://ai.rizee.in/vignan-pdf-ext/vig-solution  

// https://ai.rizee.in/vignan-pdf-ext/vig-answerkey


const UPLOAD_MODES = [ 
  { value: "key", label: "Upload Key" },
  { value: "solutions", label: "Upload Solutions" },
  { value: "both", label: "Both" }
];

const KEY_CARD = { title: "Answer Key PDF", icon: "fas fa-key", stateKey: "keyPdf", errorKey: "keyError", refKey: "keyInput", field: "answer_key_pdf", endpoint: `${API_BASE}/vig-answerkey` };
const EXPLANATION_CARD = { title: "Explanation PDF", icon: "fas fa-book", stateKey: "solutionsPdf", errorKey: "solutionsError", refKey: "solutionsInput", field: "solution_pdf", endpoint: `${API_BASE}/vig-solution` };

// Each card hits its own endpoint. In "both" mode both endpoints are called in parallel.
const MODE_CONFIG = {
  key: { cards: [KEY_CARD] },
  solutions: { cards: [EXPLANATION_CARD] },
  both: { cards: [KEY_CARD, EXPLANATION_CARD] },
};

class ExamAnswerExplanationUpload extends Component {

  state = {
    selectedExam: "",
    selectedExamType: "",
    selectedFile: "",
    uploadMode: "key",
    keyPdf: null,
    solutionsPdf: null,
    keyError: "",
    solutionsError: "",
    examError: "",
    fileError: "",
    uploading: false,
    uploadMessage: "",
    uploadError: "",
  };

  /* ---------------- IS JEE SELECTED (needs Mains/Advance) ---------------- */

  isJeeSelected = () => {
    const exam = this.state.selectedExam;
    return exam?.label?.toUpperCase().includes("JEE") || String(exam?.value) === "2";
  };

  /* ---------------- REFETCH FILE LIST ---------------- */

  refetchFiles = (examLabel, examTypeLabel) => {
    this.props.getPdfFiles.refetch({
      exams: [examLabel || "JEE"],
      institute_id: parseInt(Cookies.get("institutionid")),
      pexam_type: examTypeLabel || ""
    });
  };

  /* ---------------- EXAM CHANGE ---------------- */

  handleExamChange = (name, value, selectedOption) => {
    this.setState({ selectedExam: selectedOption, selectedExamType: "", selectedFile: "", examError: "", fileError: "" }, () => {
      this.refetchFiles(selectedOption?.label, "");
    });
  };

  /* ---------------- EXAM TYPE CHANGE (Mains / Advance) ---------------- */

  handleExamTypeChange = (name, value, selectedOption) => {
    this.setState({ selectedExamType: selectedOption, selectedFile: "" }, () => {
      this.refetchFiles(this.state.selectedExam?.label, selectedOption?.label);
    });
  };

  /* ---------------- FILE NAME SELECT (exam files dropdown) ---------------- */

  handleFileSelectChange = (name, value, selectedOption) => {
    this.setState({ selectedFile: selectedOption, fileError: "" });
  };

  /* ---------------- UPLOAD MODE CHANGE ---------------- */

  handleModeChange = (mode) => {
    // Clear any staged files/errors so a previous mode's selections don't leak over.
    this.setState({
      uploadMode: mode,
      keyPdf: null,
      solutionsPdf: null,
      keyError: "",
      solutionsError: "",
      uploadError: "",
      uploadMessage: "",
    });
  };

  /* ---------------- FILE CHANGE (5MB · PDF only) ---------------- */

  handleFileChange = (e, stateKey, errorKey) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      this.setState({ [stateKey]: null, [errorKey]: "Only PDF files allowed" });
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      this.setState({ [stateKey]: null, [errorKey]: "File must be less than 5MB" });
      return;
    }

    this.setState({ [stateKey]: file, [errorKey]: "", examError: "" });
  };

  /* ---------------- GENERATE FILE NAME ---------------- */

  generateFileName = (file) => {
    const now = new Date();
    let hours = now.getHours();
    const minutes = ("0" + now.getMinutes()).slice(-2);
    const seconds = ("0" + now.getSeconds()).slice(-2);
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    hours = ("0" + hours).slice(-2);
    const formatted = `${now.getFullYear()}${("0" + (now.getMonth() + 1)).slice(-2)}${("0" + now.getDate()).slice(-2)}_${hours}${minutes}${seconds}_${ampm}`;
    const extension = file.name.split(".").pop();
    const baseName = file.name.replace(/\.[^/.]+$/, "").replace(/\s+/g, "_");
    return `${baseName}_${formatted}.${extension}`;
  };

  /* ---------------- VALIDATE + UPLOAD ---------------- */

  handleUpload = () => {
    const { uploadMode, selectedExam, selectedExamType, selectedFile } = this.state;
    const config = MODE_CONFIG[uploadMode];
    let valid = true;

    if (selectedExam?.value == undefined) {
      this.setState({ examError: "Please select exam" });
      valid = false;
    }

    if (selectedFile?.value == undefined) {
      this.setState({ fileError: "Please select a file" });
      valid = false;
    }

    // Validate every card required by the current mode.
    const errorUpdates = {};
    config.cards.forEach((card) => {
      if (!this.state[card.stateKey]) {
        errorUpdates[card.errorKey] = `Please upload ${card.title}`;
        valid = false;
      }
    });
    this.setState(errorUpdates);
    if (!valid) return;

    // Build one request per card so each PDF is sent to its own endpoint.
    // "both" mode calls /vig-answerkey and /vig-solution in parallel.
    const requests = config.cards.map((card) => {
      const file = this.state[card.stateKey];
      const renamed = this.generateFileName(file);
      const formData = new FormData();
      formData.append(card.field, new File([file], renamed, { type: file.type, lastModified: file.lastModified }));
      formData.append("exampaper_id", selectedFile?.value);
      // formData.append("type", "college");
      // formData.append("upload_mode", uploadMode);
      // formData.append("exam", selectedExam?.label || "");
      // formData.append("pexam_type", selectedExamType?.label || "");
      return fetch(card.endpoint, { method: "PUT", body: formData }).then((res) => res.json());
    });

    this.setState({ uploading: true, uploadMessage: "", uploadError: "" });

    Promise.all(requests)
      .then((results) => {
        const failed = results.filter((data) => data.status !== "success");
        if (failed.length === 0) {
          const messages = results.map((data) => data.message).filter(Boolean);
          this.setState({
            uploading: false,
            uploadMessage: messages.join(" ") || "Uploaded successfully!",
            keyPdf: null,
            solutionsPdf: null,
          });
          config.cards.forEach((card) => {
            if (this[card.refKey]) this[card.refKey].value = "";
          });
          this.refetchFiles(selectedExam?.label, selectedExamType?.label);
          // Redirect back to the PDF List tab after a successful upload.
          if (this.props.onUploaded) this.props.onUploaded();
        } else {
          const errorMessages = failed.map((data) => data.message).filter(Boolean);
          this.setState({ uploading: false, uploadError: errorMessages.join(" ") || "Processing failed." });
        }
      })
      .catch(err => {
        this.setState({ uploading: false, uploadError: "Server error. Please try again." });
        console.error(err);
      });
  };

  /* ---------------- UPLOAD CARD RENDERER ---------------- */

  renderUploadCard = (card) => {
    const file = this.state[card.stateKey];
    const error = this.state[card.errorKey];
    return (
      <div className="col-md-6" key={card.stateKey}>
        <div
          className={`upload-card ${file ? "has-file" : ""}`}
          onClick={() => this[card.refKey] && this[card.refKey].click()}
        >
          <i className={`${card.icon} upload-icon`}></i>
          <div className="upload-title">{card.title}</div>
          <div className="upload-subtitle">Max size: 5MB · PDF only</div>
          <Form.Control
            type="file"
            accept="application/pdf"
            ref={(ref) => (this[card.refKey] = ref)}
            onChange={(e) => this.handleFileChange(e, card.stateKey, card.errorKey)}
            style={{ display: "none" }}
          />
          {file && (
            <div className="upload-file-name">
              <i className="fas fa-check-circle"></i>
              {file.name}
            </div>
          )}
          {error && (
            <div className="upload-error">
              <i className="fas fa-exclamation-circle me-1"></i>
              {error}
            </div>
          )}
        </div>
      </div>
    );
  };

  /* ---------------- RENDER ---------------- */

  render() {
    const { loading, error, getAIMLFiles } = this.props.getPdfFiles;
    const globals = this.props.globals || {};
    const exams = (globals.globals && globals.globals.exams) || [];

    if (error) {
      alert("Server Error " + error.message);
      return null;
    }

    const { uploadMode, selectedExam } = this.state;
    const config = MODE_CONFIG[uploadMode];
    const fileList = getAIMLFiles || [];

    return (
      <div>
        <Card>
          <Card.Body>
            <div className="upload-container">

              <div className="upload-section-title">
                <i className="fas fa-upload"></i>
                Upload Answer Key &amp; Explanations
              </div>

              <Row>
                {/* Select Exam Dropdown */}
                <Col lg={4} md={6} sm={6} xs={12} className="mb-4">
                  <label className="control-label">Select Exam</label>
                  <SelectDropDown
                    name="exam"
                    isClearable={false}
                    options={exams.slice(0, 2).map((exam) => ({
                      label: exam.exam,
                      value: exam.id
                    }))}
                    handleChange={this.handleExamChange}
                    stateData={this.state.selectedExam}
                  />
                  {this.state.examError && (
                    <span className="text-danger">{this.state.examError}</span>
                  )}
                </Col>

                {/* Select Exam Type (Mains / Advance) — only when JEE is selected */}
                {this.isJeeSelected() && (
                  <Col lg={4} md={6} sm={6} xs={12} className="mb-4">
                    <label className="control-label">Select Exam Type</label>
                    <SelectDropDown
                      name="examType"
                      isClearable={false}
                      options={EXAM_TYPE_OPTIONS}
                      handleChange={this.handleExamTypeChange}
                      stateData={this.state.selectedExamType}
                    />
                  </Col>
                )}

                {/* Select File — exam file names, based on the exam/exam-type selection */}
                {selectedExam?.label && (
                  <Col lg={4} md={6} sm={6} xs={12} className="mb-4">
                    <label className="control-label">Select File</label>
                    <SelectDropDown
                      name="file"
                      isClearable={false}
                      isDisabled={loading || fileList.length === 0}
                      placeholderName={loading ? "Loading files..." : (fileList.length === 0 ? "No files found" : "Select file")}
                      options={fileList.map((file) => ({
                        label: file.file_name,
                        value: file.id
                      }))}
                      handleChange={this.handleFileSelectChange}
                      stateData={this.state.selectedFile}
                    />
                    {this.state.fileError && (
                      <span className="text-danger">{this.state.fileError}</span>
                    )}
                  </Col>
                )}
              </Row>


              {/* Upload Mode Radio Buttons */}
              <Row className="mb-4">
                <Col xs={12}>
                  <label className="control-label d-block mb-2">Select Upload Type</label>
                  <div className="d-flex flex-wrap" style={{ gap: "24px" }}>
                    {UPLOAD_MODES.map((mode) => (
                      <Form.Check
                        key={mode.value}
                        type="radio"
                        id={`upload-mode-${mode.value}`}
                        name="uploadMode"
                        label={mode.label}
                        value={mode.value}
                        checked={uploadMode === mode.value}
                        onChange={() => this.handleModeChange(mode.value)}
                      />
                    ))}
                  </div>
                </Col>
              </Row>

              {/* Upload Cards (based on radio selection) */}
              <div className="row">
                {config.cards.map((card) => this.renderUploadCard(card))}
              </div>

              {/* Status messages */}
              {this.state.uploading && (
                <div className="upload-status-box loading">
                  <div className="spinner-border spinner-border-sm" style={{ color: "#4361ee" }}></div>
                  <span>Processing your PDFs, please wait...</span>
                </div>
              )}

              {this.state.uploadMessage && (
                <div className="upload-status-box success">
                  <i className="fas fa-check-circle" style={{ fontSize: "18px", color: "#06d6a0" }}></i>
                  <span>{this.state.uploadMessage}</span>
                </div>
              )}

              {this.state.uploadError && (
                <div className="upload-status-box error">
                  <i className="fas fa-times-circle" style={{ fontSize: "18px", color: "#e63946" }}></i>
                  <span>{this.state.uploadError}</span>
                </div>
              )}

              {/* Upload Button */}
              <div className="upload-btn-wrapper">
                <Button
                  className="upload-main-btn"
                  onClick={this.handleUpload}
                  disabled={this.state.uploading}
                >
                  {this.state.uploading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-cloud-upload-alt me-2"></i>
                      Upload &amp; Process
                    </>
                  )}
                </Button>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default compose(
  withRouter,
  withApollo,
  graphql(FETCH_PDF_FILES_DATA, {
    options: () => ({
      variables: {
        exams: ["JEE"],
        institute_id: parseInt(Cookies.get("institutionid")),
        pexam_type: ""
      }
    }),
    name: "getPdfFiles"
  }),
  graphql(FETCH_GLOBALS, {
    options: () => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid"))
      }
    }),
    name: "globals"
  })
)(ExamAnswerExplanationUpload);
